export function getModuleSpecs(el) {
    return (
        el.getAttribute
        && (el.getAttribute('data-js') || el.getAttribute('data-jsobj') || el.getAttribute('data-jsobjpopin'))
    );
}
